import React from "react";
import styled from "styled-components";
import { menuBlueColor } from "../../helpers";
import OutputRisks from "../output/OutputRisks";

export default function RisksOutput() {
  return (
    <Container>
      <div className="contents">
        <OutputRisks source="project" color={menuBlueColor} />
      </div>
    </Container>
  );
}

const Container = styled.div`
  padding: 20px;
  position: relative;
  h3 {
    margin-bottom: 10px;
  }
  button {
    background-color: ${menuBlueColor};
    border: none;
    color: white;
    font-weight: bold;
    padding: 10px 15px;
  }
  .contents {
    max-height: 600px;
    overflow: scroll;
  }
  .bold {
    font-weight: bold;
  }
`;
